import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaymentInformationHeader from './PaymentInformationHeader';
import PaymentSource from './PaymentSource';
import { Form } from 'semantic-ui-react';
import EmailAddress from './EmailAddress';

class SinglePaymentInformation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			source: props.source ?? { emailAddress: props.defaultEmailAddress },
		};

		this.paymentRef = React.createRef();

		this.onSourceUpdate = this.onSourceUpdate.bind(this);
		this.onSourceAdd = this.onSourceAdd.bind(this);
		this.isValid = this.isValid.bind(this);
	}

	isValid() {
		const { bypassEmailAddressCheck } = this.props;
		const { source } = this.state;
		const { emailAddress } = source;

		var valid = !!bypassEmailAddressCheck ? true : !!emailAddress && emailAddress !== '';

		if (this.paymentRef.current) {
			return valid && this.paymentRef.current.isValid();
		} else {
			return valid && true;
		}
	}

	continue() {
		this.paymentRef.current.add();
	}

	reset() {
		this.paymentRef.current.reset();
	}

	onSourceUpdate(source) {
		const { onPaymentInformationUpdate, policies, isRecurring } = this.props;
		if (!isRecurring) {
			source.amounts = {};
			policies.forEach((p) => {
				source.amounts[p.displayName] = p.amount;
			});
		}

		this.setState({ source }, () => {
			onPaymentInformationUpdate(source);
		});
	}

	onSourceAdd(source) {
		const { onPaymentInformationUpdate, onContinue, policies, isRecurring } = this.props;
		if (!isRecurring) {
			source.amounts = {};
			policies.forEach((p) => {
				source.amounts[p.displayName] = p.amount;
			});
		}

		this.setState({ source }, () => {
			onPaymentInformationUpdate(source);
			onContinue();
		});
	}

	render() {
		const { policies, payment, isRecurring, actions, defaultEmailAddress, allowMultipleEmailAddresses, bypassEmailAddressCheck, emailAddressOptions, hidePaymentOption } = this.props;
		const { source } = this.state;

		return (
			<div>
				{!isRecurring && <PaymentInformationHeader policies={policies} sources={[source]} hidePaymentOption={hidePaymentOption} />}
				<Form widths='equal' error>
					<PaymentSource ref={this.paymentRef} source={source} settings={payment.settings} banks={payment.banks} auth={payment.auth} actions={actions} onSourceUpdate={this.onSourceUpdate} onSourceAdd={this.onSourceAdd} isRecurring={isRecurring} policies={policies} userEmailAddress={defaultEmailAddress} hasRecurringPaymentSetup={this.props.hasRecurringPaymentSetup} />
                    <EmailAddress emailAddress={source.emailAddress} allowMultipleEmailAddresses={allowMultipleEmailAddresses} required={!bypassEmailAddressCheck} onChange={(value) => this.onSourceUpdate({ ...source, emailAddress: value })} emailAddressOptions={emailAddressOptions} />
				</Form>
			</div>
		);
	}
}

SinglePaymentInformation.propTypes = {
	policies: PropTypes.array.isRequired,
	payment: PropTypes.object.isRequired,
	onPaymentInformationUpdate: PropTypes.func.isRequired,
	onContinue: PropTypes.func.isRequired,
	actions: PropTypes.object.isRequired,
	allowMultipleEmails: PropTypes.bool,
	bypassEmailAddressCheck: PropTypes.bool,
};

export default SinglePaymentInformation;
